import React from "react";

// EXTRAS
import { cleanSpecialCharacters } from "../../extras";

// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { grey } from "@mui/material/colors";
import { TypographyBoldOnPrint } from "../styled";

export default function OrderTicketHeader({
  channel,
  channelMerchant,
  channelOrderCode,
  orderType,
  orderIndex,
  indoorTable,
}) {
  const getChannelOrderCode = () => {
    return orderType === "INDOOR" ? "MESA" : channelOrderCode;
  };

  return (
    <Box>
      <TypographyBoldOnPrint variant="body2" align="center" color={grey["900"]}>
        {cleanSpecialCharacters(channel)} - {getChannelOrderCode()}
      </TypographyBoldOnPrint>
      {orderType !== "INDOOR" && (
        <TypographyBoldOnPrint
          variant="body2"
          align="center"
          color={grey["900"]}
        >
          {channelMerchant}
        </TypographyBoldOnPrint>
      )}
      <TypographyBoldOnPrint
        variant="h3"
        align="center"
        fontWeight="bold"
        printsize={45}
        color={grey["900"]}
      >
        {orderType !== "INDOOR" ? orderIndex : `SALÃO ${indoorTable}`}
      </TypographyBoldOnPrint>
      <Divider sx={{ mb: "2px" }} />
    </Box>
  );
}
